<template>
    <v-footer class="pa-2" color="info" dark absoulte>
        <v-layout justify-center row wrap>
            <v-spacer></v-spacer>
            <div><strong>Vilsons Shipping Pte Ltd. |</strong> &copy; {{ new Date().getFullYear() }}</div>
        </v-layout>
    </v-footer>
</template>
<script>
export default {
    name: 'bottomfootermenus',
    data () {
      return {
        }    
    }
};
</script>